'use client';

import React from 'react';

interface ModalProps {
  isOpen: boolean;
  modalComponent: React.ReactNode;
}

/**
 * [共通]モーダルコンポーネント
 * @param param0
 * @returns
 */
const Modal: React.FC<ModalProps> = ({ isOpen, modalComponent }) => {
  // スケールアップとスケールダウンのアニメーションをインラインスタイルとして定義
  const scaleAnimation = `
    @keyframes scale-up {
      from { transform: scale(0.8); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }

    @keyframes scale-down {
      from { transform: scale(1); opacity: 1; }
      to { transform: scale(0.8); opacity: 0; }
    }
  `;

  // インラインスタイルとしてアニメーションを適用
  const modalStyle: React.CSSProperties = {
    animation: isOpen ? 'scale-up 0.2s ease-out' : 'scale-down 0.2s ease-out',
    transform: isOpen ? 'scale(1)' : 'scale(0.8)',
    opacity: isOpen ? 1 : 0,
    transition: 'transform 0.3s ease-out, opacity 0.3s ease-out'
  };

  return (
    <>
      <style>{scaleAnimation}</style>
      {isOpen && <div className="fixed inset-0 bg-black opacity-50 z-30"></div>}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-40">
          <div className={`w-full h-full`} style={modalStyle}>
            {modalComponent}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
